export interface Environment {
  centre: boolean;
  sit: boolean;
  shadows: boolean;
  occlusion: boolean;
  grid: boolean;
  underLight: boolean;
  platform: boolean;
}

export type EnvironmentToggle = keyof Environment;

export const DEFAULT_ENVIRONMENT: Environment = {
  centre: true,
  sit: true,
  shadows: true,
  occlusion: false,
  grid: true,
  underLight: false,
  platform: false,
};

/** Fixed grid spacings offered besides following the zoom, in millimetres. */
export const GRID_SPACINGS = [1, 10, 100, 1000, 10000] as const;

export interface CapturedView {
  dataUrl: string;
  width: number;
  height: number;
  /** A background picture fills the view behind the part. */
  background: boolean;
}

export type { SelectionMode } from './viewport';
